<div class="home-page-card-header-container row">
  <div class="home-page-card-header col-xs-12 col-md-10">
    <div class="home-page-card-title">{{ title | translate }}</div>
    <div class="home-page-card-header-content">
      <ng-content></ng-content>
    </div>
  </div>
  @if (imageUrl) {
    <div class="home-page-card-header-icon col-xs-2">
      <div class="home-page-card-header-image-container">
        <img [src]="getImageSrc(imageUrl)" />
      </div>
    </div>
  }
</div>
